import { useEffect, useState } from "react";
import './PlaceOrder.css'
import { apiGet, apiPost } from '../../API/httpCommon';
import { getUserDetails } from '../../Utility/UserUtility';
import Spinner from '../Spinner/Spinner';
import $, { event } from "jquery";
import { AddUpdateCart, GetCart } from '../../Utility/CartUtility';
import { buffer } from "stream/consumers";
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import config from '../../config.json';
import Order from "../order/Order";
import PaymentType from '../../Utility/PaymentType';

const PlaceOrder = () => {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [AddressId, setAddressId] = useState<any>(null);
    const [ShippingAddress, setShippingAddress] = useState<any>(null);
    const [Email, setEmail] = useState<any>();
    const [Name, setName] = useState<any>();
    const [LandMark, setLandMark] = useState<any>();
    const [ContactNumber, setContactNumber] = useState<any>();
    const [PinCode, setPinCode] = useState<any>();
    const [District, setDistrict] = useState<any>();
    const [State, setState] = useState<any>();
    const [Country, setCountry] = useState<any>('India');
    const [GSTNumber, setGSTNumber] = useState<any>();
    const [Address, setAddress] = useState<any>();
    const [TempOrderId, setTempOrderId] = useState('');
    const [ActiveSection, setActiveSection] = useState('Address');
    const [SelectedAddress, setSelectedAddress] = useState<any>();

    const [PayAmount, setPayAmount] = useState(0);
    const [ShippingAmount, setShippingAmount] = useState(0);
    const [PreDefinedShippingAmount, setPreDefinedShippingAmount] = useState(0);
    const [PromotionAppliedAmount, setPromotionAppliedAmount] = useState(0);
    const [EcashUseAmount, setEcashUseAmount] = useState(0);
    const [NetPayAmount, setNetPayAmount] = useState(0);


    const [OrderItem, setOrderItem] = useState<any>([]);
    const [SubTotalOfShippingPriceItem, setSubTotalOfShippingPriceItem] = useState<any>(0);
    const [PromotionAppliedMessage, setPromotionAppliedMessage] = useState<any>();
    const [PromoCode, setPromoCode] = useState<any>();
    const [Ecash, setEcash] = useState<any>();
    const [VoucherCode, setVoucherCode] = useState<any>('');

    const [IsProceedToPay, setIsProceedToPay] = useState(false);
    const [OrderId, setOrderId] = useState('');
    const [PaymentMode, setPaymentMode] = useState<any>(PaymentType.Online);

    const[InvalidVoucherMessage, setInvalidVoucherMessage] = useState<any>('');


    useEffect(function () {

        let userDetails = getUserDetails();

        if (userDetails === undefined || userDetails === null) {
            navigate('/Cart');
        }
        else {

            GetShippingAddress();
            CreateTempOrder();
            GetECash();

        }

    }, [])

    useEffect(function () {

        UpdateOrderAmount('');
    }, [PayAmount, SubTotalOfShippingPriceItem, ShippingAmount, PreDefinedShippingAmount, PromotionAppliedAmount, EcashUseAmount]);


    const CreateTempOrder = () => {

        const data: any = [];
        let userDetails = getUserDetails();
        let Cart = GetCart();

        Cart.map((item, index) => {
            data.push({ Item_Id: item?.Item_Id, Seller_Id: item?.Seller_Id, Quantity: item?.Quantity, User_Id: userDetails.User.User_Id });
        });

        setIsLoading(true);
        apiPost("api/PlaceOrder/CreateTempOrder", data).then((res: any) => {
            
            if (res !== undefined && res !== null && res !== "") {
                setTempOrderId(res.Data);
            }
            setIsLoading(false);
        });
    }

    const GetShippingAddress = () => {
        setIsLoading(true);

        let userDetails = getUserDetails();
        setEmail(userDetails.User.User_Email);
        apiGet("api/User/GetShippingAddress?User_Id=" + userDetails.User.User_Id).then((res: any) => {
            setShippingAddress(res?.Data);
            setIsLoading(false);
        });
    }


    const isValidAddress = () =>{
        
        let result : boolean = true;

        if(!Name){
            result = false;
        }

        if(!LandMark){
            result = false;
        }

        if(!ContactNumber){
            result = false;
        }

        if(!PinCode){
            result = false;
        }

        if(!State){
            result = false;
        }

        if(!Country){
            result = false;
        }

        if(!Address){
            result = false;
        }

        return result;

    }


    const AddUpdateShippingAddress = () => {

        if(!isValidAddress()){
            alert('Please fill all rquired fields.');
         return false;
        }

        setIsLoading(true);
        let userDetails = getUserDetails();

        const data = {
            Id: AddressId,
            User_Id: userDetails.User.User_Id,
            Email: Email,
            Contact_Name: Name,
            Land_Mark: LandMark,
            User_Contact: ContactNumber,
            Pincode: PinCode,
            Address_City: District,
            Address_State: State,
            Address_Country: Country,
            GSTNumber: GSTNumber,
            Address: Address
        }


        apiPost("api/User/AddUpdateShippingAddress", data).then((res: any) => {

            if (res !== undefined && res !== null && res !== "") {
                // setUserDetails(res);
                // setLoggedInUserDetails(res);
                //$("#UserName").text(res.User.User_Name);
                $(".btn-close").click();

                GetShippingAddress();
            }
            setIsLoading(false);

        });



    }


    const editAddress = (Id: any) => {

        setEmail('');
        setName('');
        setLandMark('');
        setContactNumber('');
        setPinCode('');
        setDistrict('');
        setState('');
        setCountry('');
        setGSTNumber('');
        setAddress('');


        setAddressId(Id);
        let address = ShippingAddress?.filter((x: any) => x?.Id == Id);


        if (address?.length > 0) {

            setEmail(address[0].Email);
            setName(address[0].Contact_Name);
            setLandMark(address[0]?.Land_Mark);
            setContactNumber(address[0]?.User_Contact);
            setPinCode(address[0]?.Pincode);
            setDistrict(address[0]?.Address_City);
            setState(address[0]?.Address_State);
            setCountry(address[0]?.Address_Country);
            setGSTNumber(address[0]?.GSTNumber);
            setAddress(address[0]?.Address);

            $("#btnAddNewAddress").click();
        }

    }

    const addNewAddress = () => {
        setName('');
        setLandMark('');
        setContactNumber('');
        setPinCode('');
        setDistrict('');
        setState('');
        setCountry('');
        setGSTNumber('');
        setAddress('');
    }

    const GetPinDetails = (pincode: any) => {

        if (pincode?.length === 6) {
            setIsLoading(true);
            apiGet("api/User/GetPinDetails?PinCode=" + pincode).then((res: any) => {

                if (res?.Data !== null) {
                    setDistrict(res?.Data.City);
                    setState(res?.Data.State);
                    setIsLoading(false);
                }
            });
        }
    }

    const DeliverToThisAddress = (item: any) => {

        setIsLoading(true);
        setSelectedAddress(item);
        apiGet("api/PlaceOrder/DeliverToThisAddress?TempOrderId=" + TempOrderId + "&AddressId=" + item?.Id).then((res: any) => {


            setActiveSection('Payment');
            setIsLoading(false);
            GetOrderPlace();
        });
    }


    const changeAddress = () => {
        setActiveSection('Address');
    }

    const GetOrderPlace = () => {

        setIsLoading(true);
        apiGet("api/PlaceOrder/GetOrderPlace?TempOrderId=" + TempOrderId).then((res: any) => {
            setOrderItem(res.Data);
            let TotalOrderAmount: number = 0;
            let PreDefinedTotalShippingPrice: number = 0;
            let SubTotalOfShippingPriceItem: number = 0;
            if (res.Data !== null) {
                res?.Data?.map((item: any) => {

                    if (item?.ShippingPrice !== null && item?.ShippingPrice > 0) {
                        SubTotalOfShippingPriceItem = SubTotalOfShippingPriceItem + item?.Sub_Total;
                        PreDefinedTotalShippingPrice = PreDefinedTotalShippingPrice + (item?.ShippingPrice * item?.Quantity);
                    }
                    else {
                        TotalOrderAmount = TotalOrderAmount + item?.Sub_Total;
                    }
                })
            }
            
            setPayAmount(TotalOrderAmount);
            if(TotalOrderAmount > 0){
                 calculateShippingAmount(TotalOrderAmount);
            }
            setPreDefinedShippingAmount(PreDefinedTotalShippingPrice);
            setSubTotalOfShippingPriceItem(SubTotalOfShippingPriceItem);

            setIsLoading(false);
        });
    }

    const calculateShippingAmount = (TotalOrderAmount: number) => {
        if (TotalOrderAmount < 500) {
            setShippingAmount(50);
        }
        else {
            setShippingAmount(0);
        }

    }






    const CheckPromoCode = () => {

        setIsLoading(true);
        apiGet("api/PlaceOrder/CheckPromoCode?PromoCode=" + PromoCode + "&orderid=" + TempOrderId).then((res: any) => {

            if (res.Data !== null) {
                setPromotionAppliedMessage(res?.Data?.Message);
                setPromotionAppliedAmount(res?.Data?.Amount);
                setIsLoading(false);
            }
        });

    }
    // PayAmount+SubTotalOfShippingPriceItem+ShippingAmount+PreDefinedShippingAmount-PromotionAppliedAmount-EcashUseAmount



    const GetECash = () => {

        setIsLoading(true);
        let userDetails = getUserDetails();
        apiGet("api/PlaceOrder/GetECash?UserId=" + userDetails.User.User_Id).then((res: any) => {

            if (res.Data !== null) {
                setEcash(res?.Data);
                setEcash((previous: any) => {
                    return res?.Data
                });

            }
            UpdateOrderAmount('ECash');
            setIsLoading(false);

        });

    }

    const ApplyECash = (e: any) => {

        if (e.target.checked) {
            setEcashUseAmount(Ecash);
        }
        else {
            setEcashUseAmount(0);
        }
    }

    const handleProceedToPay = () => {
        
        setIsLoading(true);

        let userDetails = getUserDetails();

        const data = {
            tempoid: TempOrderId,
            paymode: PaymentMode,
            payrecieve: false,
            ReqestedByPaymentGateWay: (VoucherCode ? 'PAYU' : ''),
            vochercode: VoucherCode
        }

        apiPost("api/PlaceOrder/PlaceOrder", data).then((res: any) => {
            
            setInvalidVoucherMessage('');
            if (res !== undefined && res !== null && res !== "") {
                

                let _OrderId: string = (config.IsProd ? "" : "Test_") + res?.Data.orderid;
                setOrderId(_OrderId);

                if (PaymentMode === PaymentType.Online) {
                    setIsProceedToPay(true);
                }
                else if (PaymentMode === PaymentType.Voucher) {
                    setInvalidVoucherMessage('');
                    if (res?.Data?.status === "-1") {
                        navigate('/OrderResponse/' + res?.Data.orderid);
                    }
                    else {
                        setInvalidVoucherMessage('Invalid Voucher Code');
                    }
                }
            }
            setIsLoading(false);

        });

    }


    const PayNow = (tag: any) => {
       
        const txnId = OrderId; 
        let amount = NetPayAmount;
       

        const merchantKey = process.env.REACT_APP_PAYU_MERCHANTKEY;
        const salt = process.env.REACT_APP_PAYU_SALT; 
        const hashString = merchantKey + "|" + txnId + "|" + amount + "|" + "MeripustakByPayU" + "|" + Name + "|" + Email + "|||||||||||" + salt;
        const _hash = CryptoJS.SHA512(hashString);

        type _paymentData = {
            key: any;
            txnid: any;
            amount: any;
            productinfo: any;
            firstname: any;
            phone: any;
            email: any;
            surl: any;
            furl: any;
            hash: any;
        };
       
        const paymentData: _paymentData = {
            key: merchantKey,
            txnid: txnId,
            amount: amount,
            productinfo: `MeripustakByPayU`,
            firstname: Name,
            phone: ContactNumber,
            email: Email,
            //surl: (config.IsProd ? config.ProdUrl : config.LocalUrl)+ "PaymentResponse_PayU?OID=" + txnId+"&ST=S",
            //furl: (config.IsProd ? config.ProdUrl : config.LocalUrl)+ "PaymentResponse_PayU?OID=" + txnId+"&ST=F",
            surl: config["PaymentUrl"]+ "PaymentResponse_PayU?OID=" + txnId+"&ST=S",
            furl: config["PaymentUrl"]+ "PaymentResponse_PayU?OID=" + txnId+"&ST=F",
            hash: _hash,
            // Additional parameters as needed 
        };

        // Redirect to PayUMoney payment page 
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://secure.payu.in/_payment'; // Use the live URL for production 

        Object.keys(paymentData).forEach((key: any) => {
            //
            const _key: keyof _paymentData = key;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = paymentData[_key];
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();

      
    }

    const UpdateOrderAmount = (tag: any) => {
        
        if(TempOrderId !== undefined && TempOrderId !== null && TempOrderId != '') {
        let amount: number = (PayAmount + SubTotalOfShippingPriceItem + ShippingAmount + PreDefinedShippingAmount - PromotionAppliedAmount - EcashUseAmount);
        setNetPayAmount(amount);
        setIsLoading(true);
        var data = {
            Amount: amount,
            Ecash: EcashUseAmount,
            OrderId: TempOrderId
        }
        apiPost("api/PlaceOrder/UpdateOrderAmount", data).then((res: any) => {
            
            setIsLoading(false);
        });
    }
    }


    // const OnlinePayment = () => {

    //     let amount: number = (PayAmount + SubTotalOfShippingPriceItem + ShippingAmount + PreDefinedShippingAmount - PromotionAppliedAmount - EcashUseAmount);
    //     const txnId = new Date().getTime(); // Unique transaction ID 
    //     const merchantKey = process.env.REACT_APP_PAYU_MERCHANTKEY;// 'aBQgZB'; 
    //     const salt = process.env.REACT_APP_PAYU_SALT;// 'VCG48Dfw'; 
    //     const hashString = merchantKey + "|" + txnId + "|" + amount + "|" + "MeripustakByPayU" + "|" + Name + "|" + Email + "|||||||||||" + salt;
    //     const _hash = CryptoJS.SHA512(hashString);

    //     type _paymentData = {
    //         key: any;
    //         txnid: any;
    //         amount: any;
    //         productinfo: any;
    //         firstname: any;
    //         phone: any;
    //         email: any;
    //         surl: any;
    //         furl: any;
    //         hash: any;
    //     };

    //     const paymentData: _paymentData = {
    //         key: merchantKey,
    //         txnid: txnId,
    //         amount: 1,// amount, 
    //         productinfo: `MeripustakByPayU`,
    //         firstname: Name,
    //         phone: "9899677985",
    //         email: 'ravinderkumar@machwan.in',
    //         surl: "http://localhost:3000/PaymentResponse_PayU?OID=" + txnId,
    //         furl: "http://localhost:3000/PaymentResponse_PayU?OID=" + txnId,
    //         hash: _hash,
    //         // Additional parameters as needed 
    //     };

    //     // Redirect to PayUMoney payment page 
    //     const form = document.createElement('form');
    //     form.method = 'POST';
    //     form.action = 'https://secure.payu.in/_payment'; // Use the live URL for production 

    //     Object.keys(paymentData).forEach((key: any) => {
    //         //
    //         const _key: keyof _paymentData = key;
    //         const input = document.createElement('input');
    //         input.type = 'hidden';
    //         input.name = key;
    //         input.value = paymentData[_key];
    //         form.appendChild(input);
    //     });

    //     document.body.appendChild(form);
    //     form.submit();
    // };



  const handlePaymentMode = (_paymentMode : any) =>{
    setPaymentMode(_paymentMode);
  }



    return (<>
        {(isLoading && <Spinner></Spinner>)}
        <div className=" breadcrumb-padding-180"></div>
        {/* <!-- Breadcumb Section Start --> */}
        <div className="bar">
            <div className="mainWrapper">
                <div className="statusBar">
                    <span className="pBar"></span>
                    <div className="node n0 done nConfirm0">
                        <div className="main done m0 done nConfirm0">1</div>
                        <span className="text t0 done nConfirm0">Add to Cart</span>
                    </div>
                    <div className="node n1 done nConfirm1">
                        <div className="main m1 done nConfirm1">2</div>
                        <span className="text t1 done nConfirm1">Shipping Details</span>
                    </div>
                    <div className="node n2 nConfirm2">
                        <div className="main m2 nConfirm2">3</div>
                        <span className="text t2 nConfirm2">Make Payment</span>
                    </div>

                </div>

            </div>
        </div>


        <button id='btnAddNewAddress' style={{ display: "none" }} className="btn btn-success" data-bs-toggle="modal" data-bs-target="#AddNewAddressModal">
            EditAddress
        </button>

        {(ActiveSection === 'Address') && <>

            {/* <!-- Checkout Section Start --> */}

            <section className="checkout-section fix section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 mb-3 mb-sm-0">
                            <button id='btnAddNewAddress' onClick={() => addNewAddress()} className="btn btn-success ml-10" data-bs-toggle="modal" data-bs-target="#AddNewAddressModal">
                                Add New Address
                            </button>
                        </div>
                    </div>
                    <div className="row">

                        {
                            ShippingAddress?.map((item: any) => (

                                <div className="col-sm-4 mb-3 mb-sm-0">
                                    <div className="card">
                                        <div className="card-body">
                                            <h5 className="card-title" style={{ width: "80%", float: "left" }}>{(item?.Contact_Name)}</h5>   <a style={{ width: "20%", float: "right", textAlign: "right", textDecoration: "underline", color: "blue" }} onClick={() => editAddress(item?.Id)}>Edit</a>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.Email)}</p>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.Address)}</p>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.Pincode)}</p>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.User_Contact)}</p>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.Address_City)}</p>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.Addess_State)}</p>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.GSTNumber)}</p>
                                            <p className="card-text" style={{ width: "100%", float: "left" }}>{(item?.Land_Mark)}</p>

                                            <a onClick={() => DeliverToThisAddress(item)} className="btn btn-primary" style={{ float: "right" }}>Deliver to this address</a>
                                        </div>
                                    </div>
                                </div>

                            )

                            )
                        }

                    </div>

                </div>
            </section>   </>}


        {/* <!-- Login Modal --> */}
        <div className="modal fade modal-fullscreen-md-down" id="AddNewAddressModal" tabIndex={-1} aria-labelledby="loginModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-body">

                        <div className="identityBox">
                            <div className="close-btn">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="form-wrapper otp">
                                {/* <img src="assets/img/otp.jpg" className=" center" /><br /> */}
                                <h3 id="registrationModalLabel">Add New Address</h3>

                                <div className="row">
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">Email address</label>
                                            <input type="text"  value={Email} onChange={(e) => setEmail(e.target.value)} className="form-control" placeholder="Email address" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">Name<span style={{color:"red"}} >*</span></label>
                                            <input type="text" value={Name} onChange={(e) => setName(e.target.value)} className="form-control" placeholder="Name" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">Land Mark<span style={{color:"red"}} >*</span></label>
                                            <input type="text" value={LandMark} onChange={(e) => setLandMark(e.target.value)} className="form-control" placeholder="Land Mark" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">Contact Number<span style={{color:"red"}} >*</span></label>
                                            <input type="text" value={ContactNumber} onChange={(e) => setContactNumber(e.target.value)} className="form-control" placeholder="Contact Number" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">Pin Code<span style={{color:"red"}} >*</span></label>
                                            <input type="text" value={PinCode} maxLength={6} onChange={(e) => { setPinCode(e.target.value); GetPinDetails(e.target.value); }} className="form-control" placeholder="Pin Code" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">District / City<span style={{color:"red"}} >*</span></label>
                                            <input type="text" value={District} onChange={(e) => setDistrict(e.target.value)} className="form-control" placeholder="District / City" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">State<span style={{color:"red"}} >*</span></label>
                                            <input type="text" value={State} onChange={(e) => setState(e.target.value)} className="form-control" placeholder="State" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">Country<span style={{color:"red"}} >*</span></label>
                                            <input type="text" value={Country} onChange={(e) => setCountry(e.target.value)} className="form-control" placeholder="Country" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">GST Number</label>
                                            <input type="text" value={GSTNumber} onChange={(e) => setGSTNumber(e.target.value)} className="form-control" placeholder="GST Number" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="mb-3">
                                            <label style={{ float: "left" }} className="form-label">Address<span style={{color:"red"}} >*</span></label>
                                            <textarea rows={3} value={Address} onChange={(e) => setAddress(e.target.value)} className="form-control" placeholder="Address" />
                                        </div>
                                    </div>
                                </div>



                                <div className="loginBtn">
                                    <a onClick={(e) => AddUpdateShippingAddress()} className="theme-btn rounded-0">{((AddressId != null && AddressId > 0) ? 'Update' : 'Add')} Address </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Payment Section Start  */}
        {(ActiveSection === 'Payment') && <section className="checkout-section fix section-padding">
            <div className="container">
                <div className="row g-5">
                    <div className="col-lg-8">
                        <div className="payment-mode">
                            <div className="wid-title">
                                <br /><h5>Select Your Payment Method</h5>
                            </div><br />
                            <div className="row product-checout-area">

                                <div className="col-xl-4 col-lg-4 order-md-1 wow fadeInUp" data-wow-delay=".3s">
                                    <div className="main-sidebar">

                                        <div className="single-sidebar-widget">

                                            <div className="categories-list">
                                                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link active" id="pills-Online-tab" data-bs-toggle="pill"
                                                            data-bs-target="#pills-Online" type="button" role="tab"
                                                            aria-controls="pills-Online" aria-selected="true" onClick={()=>{handlePaymentMode(PaymentType?.Online)}} >Online Payment</button>
                                                    </li>
                                                    {/* <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-PCD-tab" data-bs-toggle="pill"
                                                            data-bs-target="#pills-PCD" type="button" role="tab"
                                                            aria-controls="pills-PCD" aria-selected="false">Paytm/Credit/Debit</button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-GUP-tab" data-bs-toggle="pill"
                                                            data-bs-target="#pills-GUP" type="button" role="tab"
                                                            aria-controls="pills-GUP" aria-selected="false">G Pay/UPI/PhonePe</button>
                                                    </li> */}
                                                     <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-Voucher-tab" data-bs-toggle="pill"
                                                            data-bs-target="#pills-Online" type="button" role="tab"
                                                            aria-controls="pills-Voucher" aria-selected="false"  onClick={()=>{handlePaymentMode(PaymentType?.Voucher)}} >E-Gift / Voucher </button>
                                                    </li> 

                                                </ul>
                                            </div>
                                        </div>



                                    </div>

                                    <div className="checkout-order-area">
                            <div className="product-checout-area">
                                <div className="checkout-item d-flex align-items-center justify-content-between">
                                    <p>Promocode:</p>
                                </div>

                                <div className="cart-wrapper-footer">
                                    <form action="#">
                                        <div className="row">
                                            <div className="col-md-12"><input className="input-area1" type="text" onChange={(e) => { setPromoCode(e.target.value) }} name="Coupon Code" placeholder="Enter Promo Code here" /></div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <span style={{ color: (PromotionAppliedMessage === 'Success' ? 'green' : 'red') }}> {PromotionAppliedMessage}</span>
                                            </div>
                                            <div className="col-md-12">
                                                <br/>
                                                <button type="button" onClick={() => { CheckPromoCode() }} className="theme-btn btnblu">
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                            <br/>
                                                <input className="" onClick={(e) => ApplyECash(e)} type="checkbox" />{" "} Apply eCash : {Ecash}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                                </div>
                                <div className="col-xl-8 col-lg-8 order-1 order-md-2">
                                    <div className="tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-Online" role="tabpanel"
                                            aria-labelledby="pills-Online-tab" tabIndex={0}>
                                            <div className="checkout-single-wrapper">
                                                <div className="checkout-single boxshado-single">
                                                    <h5>Pay using Net Banking/Credit Card/Debit Card/UPI </h5>
                                                    <div className="">
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Shipping and handling charges :</p>
                                                            <p><b>Rs. {(ShippingAmount + PreDefinedShippingAmount)}/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Total Payable Amount :</p>
                                                            <p> <b>Rs. {(PayAmount + SubTotalOfShippingPriceItem)}/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Promo Code :</p>
                                                            <p><b>Rs. {PromotionAppliedAmount}/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>eCash :</p>
                                                            <p><b>Rs. {EcashUseAmount}/-</b></p>
                                                        </div>

                                                        {
                                                            (PaymentMode === PaymentType?.Voucher) && <>

                                                                <input name="txtVoucherCode" onChange={(e) => setVoucherCode(e?.target?.value)} type="text" id="txtVoucherCode"
                                                                    placeholder="Enter Voucher Code" style={{
                                                                        height: "39px", width: "60%", borderRadius: "5px",
                                                                        marginTop: "10px"
                                                                    }} />
                                                                   <b style={{color:"red"}} > {InvalidVoucherMessage} </b>
                                                                     </>
                                                        }

                                                        <div className="border"></div>
                                                       

                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Grand Total :</p>
                                                            <p> <b>Rs. {(PayAmount + SubTotalOfShippingPriceItem + ShippingAmount + PreDefinedShippingAmount - PromotionAppliedAmount - EcashUseAmount)} /-</b></p>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="pills-PCD" role="tabpanel"
                                            aria-labelledby="pills-PCD-tab" tabIndex={0}>
                                            <div className="checkout-single-wrapper">
                                                <div className="checkout-single boxshado-single">
                                                    <h4>Pay using Paytm</h4>
                                                    <div className="product-checout-area">
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Shipping and handling charges :</p>
                                                            <p><b>Rs. 1.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Total Payable Amount :</p>
                                                            <p> <b>Rs. 1.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Promo Code :</p>
                                                            <p><b>Rs. 0.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>eCash :</p>
                                                            <p><b>Rs. 0.00/-</b></p>
                                                        </div>
                                                        <div className="border"></div>

                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Grand Total :</p>
                                                            <p> <b>Rs. 2.00 /-</b></p>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="pills-GUP" role="tabpanel"
                                            aria-labelledby="pills-GUP-tab" tabIndex={0}>
                                            <div className="checkout-single-wrapper">
                                                <div className="checkout-single boxshado-single">
                                                    <h4>Pay using G Pay/UPI/PhonePe </h4>
                                                    <div className="product-checout-area">
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Shipping and handling charges :</p>
                                                            <p><b>Rs. 1.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Total Payable Amount :</p>
                                                            <p> <b>Rs. 1.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Promo Code :</p>
                                                            <p><b>Rs. 0.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>eCash :</p>
                                                            <p><b>Rs. 0.00/-</b></p>
                                                        </div>
                                                        <div className="border"></div>

                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Grand Total :</p>
                                                            <p> <b>Rs. 2.00 /-</b></p>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="pills-Voucher" role="tabpanel"
                                            aria-labelledby="pills-Voucher-tab" tabIndex={0}>
                                            <div className="checkout-single-wrapper">
                                                <div className="checkout-single boxshado-single">
                                                    <h4>Pay using Egift / Voucher </h4>
                                                    <div className="product-checout-area">
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Shipping and handling charges :</p>
                                                            <p><b>Rs. 1.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Total Payable Amount :</p>
                                                            <p> <b>Rs. 1.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Promo Code :</p>
                                                            <p><b>Rs. 0.00/-</b></p>
                                                        </div>
                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>eCash :</p>
                                                            <p><b>Rs. 0.00/-</b></p>
                                                        </div>
                                                        <input name="txtPromoCode" type="text" id="txtPromoCode" placeholder="Enter Voucher Code" style={{ height: "39px", width: "60%", borderRadius: "5px", marginTop: "10px" }} />
                                                        <div className="border"></div>

                                                        <div className="checkout-item d-flex align-items-center justify-content-between">
                                                            <p>Grand Total :</p>
                                                            <p><b> Rs. 2.00 /-</b></p>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <center>
                                        {/* <button   className="theme-btn btnpnk" onClick={ ()=>SubmitOrder('Online')} >Place Order</button> */}

                                       {!IsProceedToPay && <> <button  className="theme-btn btnpnk" type="submit" onClick={e => handleProceedToPay()} >Place Order</button> </>}
                                       {IsProceedToPay && <> <button  className="theme-btn theme-btnPayNow btnPayNow" type="submit"  onClick={e => PayNow(e)} >Pay Now</button>  </>}
                                    </center>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="col-lg-4">
                       
                        <br />
                        <div className="new-right b-r">

                            <h3><i className="fa fa-truck"></i> Your Shipping Details</h3>

                            <div className="mycart bg-white a-b">
                                <p><b>{SelectedAddress?.Contact_Name}</b></p>
                                <p>{SelectedAddress?.Email}</p>
                                <p>{SelectedAddress?.Address}</p>
                                <p>{SelectedAddress?.Pincode}</p>
                                <p>{SelectedAddress?.User_Contact}</p>
                                <p>{SelectedAddress?.Address_City}</p>
                                <p>{SelectedAddress?.Addess_State}</p>
                                <p>{SelectedAddress?.GSTNumber}</p>
                                <p>{SelectedAddress?.Land_Mark}</p>
                                <a href="#" onClick={() => changeAddress()}>Change Address</a>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </section>
        }






    </>);

}

export default PlaceOrder;